import ParagraphOverrides from './Blocks/Overrides/Paragraph';
import HeadingOverrides from './Blocks/Overrides/Heading';
import ListOverrides from './Blocks/Overrides/List';

ParagraphOverrides();
HeadingOverrides();
ListOverrides();
